export type PostContentSegment = {
  text: string;
  isMention: boolean;
};

export interface MentionRange {
  start_index: number;
  end_index: number;
  display_name?: string;
}

const defaultContentSegments: PostContentSegment[] = [{ text: '', isMention: false }];

const buildPostContentSegments = (
  content: string,
  mentions?: MentionRange[] | null,
): PostContentSegment[] => {
  if (!content) return defaultContentSegments;
  if (!mentions?.length) return [{ text: content, isMention: false }];

  const normalizedMentions = mentions
    // First, filter out mentions with invalid indices
    .filter(
      (mention) =>
        mention.start_index >= 0 &&
        mention.end_index > mention.start_index &&
        mention.end_index <= content.length,
    )
    // Then, filter by display name match
    .filter((mention) => {
      if (!mention.display_name) return true;

      const textAtMention = content.slice(
        mention.start_index,
        mention.end_index,
      );
      return (
        textAtMention.trim().toLowerCase() ===
        mention.display_name.trim().toLowerCase()
      );
    })
    .sort(
      (firstMention, secondMention) =>
        firstMention.start_index - secondMention.start_index ||
        firstMention.end_index - secondMention.end_index,
    );

  const segments: PostContentSegment[] = [];
  let cursor = 0;

  normalizedMentions.forEach((mention) => {
    if (mention.start_index < cursor) return;

    if (cursor < mention.start_index) {
      segments.push({
        text: content.slice(cursor, mention.start_index),
        isMention: false,
      });
    }

    segments.push({
      text: content.slice(mention.start_index, mention.end_index),
      isMention: true,
    });

    cursor = mention.end_index;
  });

  if (cursor < content.length) {
    segments.push({
      text: content.slice(cursor),
      isMention: false,
    });
  }

  return segments.length > 0 ? segments : [{ text: content, isMention: false }];
};

export default buildPostContentSegments;
